import styled from 'styled-components'

const MODAL_MIN_WIDTH = '300px'
const MODAL_MAX_WIDTH = '650px'

export const ModalMessage = styled.div`
  min-width: ${MODAL_MIN_WIDTH};
  max-width: ${MODAL_MAX_WIDTH};
  padding-right: 45px;
  margin-bottom: 30px;

  * {
    max-width: 100%;
  }

  h2 {
    font-family: ${(props) => props.theme.typography.fontFamily};
    text-transform: none;
    font-size: 20px;
    margin-top: 0;
  }

  ul {
    list-style: disc;
  }

  li {
    display: list-item;
    margin-left: 30px;
    margin-bottom: 20px;
  }
`
